import { isRowSent } from '@features/buyer-line-items-pagination/utils/is-row-sent';
import { originalItemsById } from '@features/buyer-line-items-pagination/utils/original-items-by-id';
import type { ID, Lot, LotChanges } from 'types';
import type { LotsIdErrors } from '@features/buyer-line-items-pagination/types/id-error-state';

export interface HasSentRowErrorsParams {
  changes: Record<ID, LotChanges>;
  lotsIdErrors: LotsIdErrors;
  originalLots: Lot[];
}

export const hasSentRowErrors = ({ changes, lotsIdErrors, originalLots }: HasSentRowErrorsParams): boolean => (
  Object.entries(changes ?? {}).some(([lotId, lotChanges]) => {
    const lotErrors = lotsIdErrors?.[lotId];
    if (!lotErrors) return false;

    const erroredRowIds = Object.keys(lotChanges?.line_items ?? {}).filter(id => lotErrors[id]?.length);
    if (!erroredRowIds.length) return false;

    const items = originalItemsById(originalLots.find(lot => String(lot.id) === lotId));
    return erroredRowIds.some(lineItemId => isRowSent({ lineItemId, lotChanges, originalItemsById: items }));
  })
);
